/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Jobs_Tailor_Resume_DescInputs */

const en_jobs_tailor_resume_desc = /** @type {(inputs: Jobs_Tailor_Resume_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generate a tailored version of "${i?.title}" for this job.`)
};

const de_jobs_tailor_resume_desc = /** @type {(inputs: Jobs_Tailor_Resume_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generiere eine angepasste Version von "${i?.title}" für diese Stelle.`)
};

const fr_jobs_tailor_resume_desc = /** @type {(inputs: Jobs_Tailor_Resume_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Générer une version adaptée de "${i?.title}" pour cet emploi.`)
};

const es_jobs_tailor_resume_desc = /** @type {(inputs: Jobs_Tailor_Resume_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generar una versión adaptada de "${i?.title}" para este empleo.`)
};

const it_jobs_tailor_resume_desc = /** @type {(inputs: Jobs_Tailor_Resume_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Genera una versione personalizzata di "${i?.title}" per questo lavoro.`)
};

const nl_jobs_tailor_resume_desc = /** @type {(inputs: Jobs_Tailor_Resume_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Genereer een op maat gemaakte versie van "${i?.title}" voor deze baan.`)
};

const pl_jobs_tailor_resume_desc = /** @type {(inputs: Jobs_Tailor_Resume_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wygeneruj spersonalizowaną wersję "${i?.title}" dla tej oferty.`)
};

const fi_jobs_tailor_resume_desc = /** @type {(inputs: Jobs_Tailor_Resume_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Luo räätälöity versio ansioluettelosta "${i?.title}" tähän työpaikkaan.`)
};

const da_jobs_tailor_resume_desc = /** @type {(inputs: Jobs_Tailor_Resume_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generer en skræddersyet version af "${i?.title}" til dette job.`)
};

const sv_jobs_tailor_resume_desc = /** @type {(inputs: Jobs_Tailor_Resume_DescInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Generera en skräddarsydd version av "${i?.title}" för detta jobb.`)
};

/**
* | output |
* | --- |
* | "Generate a tailored version of \"{title}\" for this job." |
*
* @param {Jobs_Tailor_Resume_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_tailor_resume_desc = /** @type {((inputs: Jobs_Tailor_Resume_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_Tailor_Resume_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_tailor_resume_desc(inputs)
	if (locale === "fr") return fr_jobs_tailor_resume_desc(inputs)
	if (locale === "es") return es_jobs_tailor_resume_desc(inputs)
	if (locale === "it") return it_jobs_tailor_resume_desc(inputs)
	if (locale === "nl") return nl_jobs_tailor_resume_desc(inputs)
	if (locale === "pl") return pl_jobs_tailor_resume_desc(inputs)
	if (locale === "fi") return fi_jobs_tailor_resume_desc(inputs)
	if (locale === "da") return da_jobs_tailor_resume_desc(inputs)
	if (locale === "sv") return sv_jobs_tailor_resume_desc(inputs)
	return en_jobs_tailor_resume_desc(inputs)
});